<template>
  <div class="sky-service-survey">
    <div class="survey-buttons">
      <!-- 服务问卷按钮 -->
      <el-tooltip content="点击进入：服务内容调研问卷" placement="left">
        <el-button type="primary" @click="handleClick">
          <i class="el-icon-star-on" style="font-size: 18px;"
            ><font style="font-size: 14px;font-weight: bold;">服务问卷</font></i
          >
        </el-button>
      </el-tooltip>
    </div>
  </div>
</template>
<script type="text/babel">
import { Button, Tooltip } from 'element-ui'

export default {
  name: 'SkyServiceSurvey',
  inject: ['rootView', 'elForm'],
  components: {
    [Button.name]: Button,
    [Tooltip.name]: Tooltip
  },
  props: {},
  data() {
    return {}
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    handleClick() {
      window.open('https://ruijie.feishu.cn/share/base/form/shrcntkcADkOBxbY0masudtN3Lg', '_blank')
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(service-survey) {
  & .survey-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  & .el-button {
    font-size: 14px;
    padding: 10px 10px;
    border-radius: 25px;
  }
}
</style>
